import React, { useEffect, useCallback, useState } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import 'moment/locale/pt-br';
import MomentUtils from '@date-io/moment';
import {
  ThemeProvider,
  createMuiTheme,
  responsiveFontSizes,
} from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import axios from 'axios';
import moment from 'moment';
import { PersistGate } from 'redux-persist/integration/react';

// import './config/ReactotronConfig';

import api from '~/services/api';

import Routes from './routes';
import RouteUpdater  from './routes/RouteUpdater';
import history from './services/history';
import { store, persistor } from './store';
import GlobalStyle from './styles/global';
import ThemeCustom from './styles/theme';

moment.locale('pt-br');

export default function App() {
  const [loading, setLoading] = useState(false);
  const [theme, setTheme] = useState(ThemeCustom);

  const handleGetObjectWeb = useCallback(async () => {
    try {
      setLoading(true);

      let URL = `${process.env.REACT_APP_URL_REQUEST}webconfig`;
      let subdominio = window.location.hostname.split('.')[0];

      // DAGNO TESTE
      const response = await fetch('config.json', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
      const datalocal = await response.json();
      if (datalocal?.URL_BACKEND && datalocal.URL_BACKEND.length > 0) {
        api.defaults.baseURL = datalocal.URL_BACKEND;
        URL = `${datalocal?.URL_BACKEND}webconfig`;
        subdominio = '';
      }
      // DAGNO TESTE FIM

      // const URL = `${process.env.REACT_APP_URL_REQUEST}webconfig`;
      // const subdominio = window.location.hostname.split('.')[0];

      const favicon = document.getElementById('favicon');

      const { data } = await axios.post(URL, {
        subdominio,
        usuario: '',
        senha: '',
        captcha: '',
      });

      setTheme((state) => ({
        ...state,
        palette: data.palette,
        logoButtonBorderRadius: data.logoButtonBorderRadius,
      }));

      // Set data in Storage
      sessionStorage.setItem('web', JSON.stringify(data));

      // Change Favicon
      if (data.favicon) favicon.href = data.favicon;

      // Change Title
      document.title = data.site_name || 'SCA+ Abastek';
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    handleGetObjectWeb();
  }, []);

  if (loading)
    return (
      <div
        style={{
          width: '100%',
          height: 'calc(100vh - 1rem)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src="/loading.gif" alt="Carregando" style={{ width: '5rem' }} />
      </div>
    );

  return (
    <Provider store={store}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <PersistGate persistor={persistor}>
          <Router history={history}>
            <RouteUpdater />
            <ThemeProvider theme={responsiveFontSizes(createMuiTheme(theme))}>
              <Routes />
              <GlobalStyle />
              <ToastContainer autoClose={3000} />
            </ThemeProvider>
          </Router>
        </PersistGate>
      </MuiPickersUtilsProvider>
    </Provider>
  );
}
